import React, { Component } from 'react';
import People from './People';
import Generate from './Generate';
import Header from './Header';
import Note from './Note';
import Footer from './Footer';
import aes from 'crypto-js/aes';
import cryptojs from 'crypto-js';
import './scss/styles.scss';
import axios from 'axios';

class SecretSanta extends Component {
	componentDidMount(callback) {
		axios.get(`${window.location.protocol}//${window.location.hostname}/api/users`)
			.then(res => {
				let items = res.data;
				if (!!callback) {
					callback(items);
				}
				return this.setState({ people: items })

			})

			.catch(err => {
				console.log(err);
				let items = { result: 'error', error: err }

				if (!!callback) {
					callback(items);
				}
			})
	}

	constructor(props) {
		super(props);

		this.state = {
			people: {},

			// people: [
			// 	"Arh",      // 0
			// 	"Катя",     // 1
			// 	"Михалыч",  // 2
			// 	"Ульяна",   // 3
			// 	"Юрич",     // 4
			// 	"Алёна",    // 5
			// 	"Никита",   // 6
			// 	"Елена", 		// 7
			// 	"Fenuks",   // 8				
			// 	"Леонид",		// 9
			// 	"Юлия",			// 10
			// 	"Андрей",		// 11
			// 	"Юлия Вейт",// 12
			// 	"Григорий"  // 13
			// ],

			santas: [],
			copied: false,
			hidden: true,
			message: "",
			params: this.getSearchParameters()
		};
	}

	encryptString(string) {
		const key = process.env.REACT_APP_ENCRYPT_KEY
		// const key = process.env.REACT_APP_ENCRYPT_KEY = '123456789abcdefg'
		return aes.encrypt(string, key)
	}

	decryptHash(hash) {
		const key = process.env.REACT_APP_ENCRYPT_KEY
		// const key = process.env.REACT_APP_ENCRYPT_KEY = '123456789abcdefg'
		const plaintext = aes.decrypt(hash.toString(), key)
		return plaintext.toString(cryptojs.enc.Utf8)
	}

	transformToArray(prmstr) {
		let params = {};
		let prmarr = prmstr.split("&");
		for (let i = 0; i < prmarr.length; i++) {
			let tmparr = prmarr[i].split("=");
			params[tmparr[0]] = tmparr[1];
		}
		return params;
	}

	getSearchParameters() {
		let prmstr = window.location.search.substr(1);
		return prmstr !== null && prmstr !== "" ? this.transformToArray(prmstr) : {};
	}

	shuffleArray(array) { // Sattolo's algorithm
		for (let i = array.length - 1; i > 0; i--) {
			const j = Math.floor(Math.random() * i);
			const temp = array[i];
			array[i] = array[j];
			array[j] = temp;
		}
		return array;
	}

	handleAddPersonParent = (name) => {
		name = name.toLowerCase();
		console.log(name)
		if (name === "") {
			this.setState({
				hidden: false,
				message: "Please enter a valid name!"
			})
		}
		else if (this.state.people.indexOf(name) !== -1) { // -1 means in array
			this.setState({
				hidden: false,
				message: "This person has already been added!"
			})
		}
		else { // if not blank AND not in array already
			this.setState((prevState) => {
				return {
					hidden: true,
					people: prevState.people.concat(name),
					santas: []
				}
			})
		}
		console.log('this.state.people', this.state.people)
	}

	handleDeletePerson = (name) => {
		this.setState((prevState) => {
			return {
				people: prevState.people.filter(item => item !== name)
			}
		})
	}

	handleGenerate = () => {
		const peoples = this.state.people.map(el => el.name);
		const newArray = this.state.people.map(el => el.name); // copy array
		const santas = this.shuffleArray(newArray);

		if (this.state.people.length <= 2) {
			this.setState({
				hidden: false,
				message: "You need at least 3 people to generate Secret Santas!"
			})
		} else {
			let exec = true;

			this.state.people.map((person, index) => {
				person.exec.map((execPerson, index) => {
					if (santas.indexOf(person.name) === peoples.indexOf(execPerson)) {
						console.warn('%cALARM', 'color: orange', 'Exception', person.name, execPerson);
						exec = false;
					}
				})
			})

			if (exec) {
				let encryptSantas = [];
				santas.map((item, index) => {
					encryptSantas.push(this.encryptString(item).toString())
				})

				this.setState(() => {
					return {
						hidden: true,
						santas: encryptSantas
					}
				})

				// setTimeout(() => {
				this.handleUpdateUsers(encryptSantas)
				// }, 500);
			} else {
				this.handleGenerate()
			}
		}
	}

	handleUpdateUsers = (santas) => {
		// axios.post(`http://localhost:3010/api/santas/${encodeURI(santas)}`)
		// axios.post(`http://localhost:3010/api/santas`, this.state.santas, {
		// 	dataType: 'json',
		// 	'Access-Control-Allow-Origin': '*',
		// 	'Access-Control-Allow-Methods': 'GET,PUT,POST,DELETE'
		// })
		axios.post(`${window.location.protocol}//${window.location.hostname}/api/santas/`, { santas })
			// axios({
			// 	method: 'post',
			// 	url: 'http://localhost:3010/api/santas',
			// 	data: JSON.stringify({  username: 'stackoverflowGuru'  }),
			// 	// headers: { Authorization: `Bearer ${yourToken}` },
			// 	timeout: 1000 // Ограничение времени ожидания запроса
			// })
			.then(function (response) {
				console.log(response);
			})
			.catch(function (error) {
				console.log(error);
			});
	}

	render() {
		let generateErrorMessage;
		generateErrorMessage = (
			<p style={{ color: "#d53743", fontSize: ".75rem", textAlign: "center", marginTop: "-.75rem" }}>{this.state.message}</p>
		)

		if (this.state.params.name !== undefined) {
			return (
				<div className="container">
					<Header />
					<Note name={this.state.params.name} mykey={this.state.params.key} decryptHash={this.decryptHash} />
				</div>
			)
		}

		return (
			<div className="body-wrap">
				<div className="container wrap" style={{ minWidth: 350 }}>
					<Header />
					<Generate handleGenerate={this.handleGenerate} text={"Generate Secret Santa"} />
					{!this.state.hidden ?
						generateErrorMessage
						: null}
					{/* <AddPerson handleAddPersonParent={this.handleAddPersonParent} /> */}
					<People
						people={this.state.people}
						santas={this.state.santas}
						handleDeletePerson={this.handleDeletePerson}
						encryptString={this.encryptString}
					/>
				</div>
				<div className="container">
					<Footer />
				</div>
			</div>
		);
	}
}

export default SecretSanta;
